var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.6,12.5c0-6.6,5.3-11.9,11.9-11.9s11.9,5.3,11.9,11.9s-5.3,11.9-11.9,11.9S0.6,19.1,0.6,12.5z M11.2,12.5 c0,0.5,0.2,0.8,0.5,1.1l5.3,3.9c0.6,0.5,1.4,0.3,1.9-0.2c0.5-0.5,0.3-1.4-0.2-1.9l0,0l-4.9-3.6v-6c0-0.8-0.6-1.3-1.3-1.3 c-0.8,0-1.3,0.6-1.3,1.3v6.6H11.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history_icon.8e7150e9d8110c8c5fdf3c60eb8089c4.svg";
export { ForwardRef as ReactComponent };